<template>
  <v-flex class="pb-4 body-1">
    <router-link :to="`/paymentMethods/?linkcode=${$route.query.linkcode}`">
      {{ text.change }}
    </router-link>
  </v-flex>
</template>

<script>
export default {
  computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          change: 'Change payment method'
        }
      } else {
        obj = {
          change: 'เปลี่ยนวิธีชำระเงิน'
        }
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped></style>
